








import { GeneralMixin } from "@/mixins/general-mixin";
import mixins from "vue-typed-mixins";
import Vue from "vue";
export default mixins(GeneralMixin).extend({
  name: "FooterGeneralNoBg",
});
